import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./app.scss";
import { Paths } from "shared/types/navigation";
import Challenges from "views/Challenges/Challenges";
import AppTemplate from "shared/components/AppTemplate/AppTemplate";
import ChallengeDetails from "views/Challenges/ChallengeDetails/ChallengeDetails";
import Profile from "views/Profile/Profile";
import Solutions from "views/Solutions/Solutions";
import SolutionDetails from "views/Solutions/SolutionsDetails/SolutionsDetails";
import MySolutions from "views/MySolutions/MySolutions";
import Resources from "views/Resources/Resources";
import ScrollToTop from "shared/components/ScrollToTop/ScrollToTop";
import PathsView from "views/Paths/Paths";
import PathDetails from "views/Paths/PathDetails/PathDetails";
import SubmitSolution from "views/Challenges/ChallengeDetails/SubmitSolution/SubmitSolution";
import EditChallengeDetails from "views/Challenges/EditChallengeDetails/EditChallengeDetails";
import Certificate from "views/Paths/Certificate/Certificate";
import NotFound from "shared/components/NotFound/NotFound";
import Notifications from "views/Notifications/Notifications";
import Badges from "views/Badges/Badges";
import TermsOfUse from "views/Policy/TermsOfUse";
import PrivacyPolicy from "views/Policy/PrivacyPolicy";
import TopUsers from "views/Badges/TopUsers/TopUsers";
import useDropdown from "shared/components/Dropdown/useDropdown";
import { ProficientLevel } from "shared/types/level";
import Settings from "views/Settings/Settings";
import FeedbacksFeed from "views/Feedbacks/FeedbacksFeed";

const challengesOptions = [
  { value: "not-completed", label: "Not Completed" },
  { value: "completed", label: "Completed" },
];

const pathOptions = [
  { value: "Responsive", label: "Responsive" },
  { value: "Front-end", label: "Front-end" },
  { value: "Full-stack", label: "Full-stack" },
];

const levelOptions = [
  { value: 0, label: ProficientLevel.beginner },
  { value: 1, label: ProficientLevel.elementary },
  { value: 2, label: ProficientLevel.intermediate },
  {
    value: 3,
    label: ProficientLevel.upperIntermediate,
  },
  { value: 4, label: ProficientLevel.advanced },
  { value: 5, label: ProficientLevel.proficient },
];

const App = () => {
  const challengeDropdown = useDropdown({
    options: challengesOptions,
  });
  const pathDropdown = useDropdown({ options: pathOptions });
  const levelDropdown = useDropdown({ options: levelOptions });

  return (
    <Router>
      <ScrollToTop />

      <AppTemplate>
        <Switch>
          <Route exact path={Paths.feekbacks}>
            <FeedbacksFeed />
          </Route>

          <Route exact path={Paths.settings}>
            <Settings />
          </Route>

          <Route exact path={Paths.privacyPolicy}>
            <PrivacyPolicy />
          </Route>

          <Route exact path={Paths.termOfUse}>
            <TermsOfUse />
          </Route>

          <Route exact path={Paths.notifications}>
            <Notifications />
          </Route>

          <Route exact path={Paths.paths}>
            <PathsView />
          </Route>

          <Route exact path={Paths.badges}>
            <Badges />
          </Route>

          <Route exact path={Paths.topUsers}>
            <TopUsers />
          </Route>

          <Route exact path={Paths.pathDetails}>
            <PathDetails />
          </Route>

          <Route exact path={Paths.resources}>
            <Resources />
          </Route>

          <Route exact path={Paths.mySolutions}>
            <MySolutions />
          </Route>

          <Route exact path={Paths.challengeDetails}>
            <ChallengeDetails />
          </Route>

          <Route exact path={Paths.editChallengeDetails}>
            <EditChallengeDetails />
          </Route>

          <Route exact path={Paths.challenges}>
            <Challenges
              challengeDropdown={challengeDropdown}
              pathDropdown={pathDropdown}
              levelDropdown={levelDropdown}
            />
          </Route>

          <Route exact path={Paths.profile}>
            <Profile />
          </Route>

          <Route exact path={Paths.certificate}>
            <Certificate />
          </Route>

          <Route exact path={Paths.solutionDetails}>
            <SolutionDetails />
          </Route>

          <Route exact path={Paths.solutions}>
            <Solutions />
          </Route>

          <Route exact path={Paths.submitSolution}>
            <SubmitSolution />
          </Route>

          <Route exact path="/">
            <PathsView />
          </Route>

          <Route path="/">
            <NotFound />
          </Route>
        </Switch>
      </AppTemplate>
    </Router>
  );
};

export default App;
